import { Create, Edit, SimpleForm, TextInput, SelectInput, DateField, ReferenceInput } from 'react-admin';
import { useSearchParams } from 'react-router-dom';
import { Box, Alert } from '@mui/material';
import { INCIDENT_SEVERITY, INCIDENT_STATUS } from './constants';

export const IncidentCreate = () => {
  const [searchParams] = useSearchParams();
  const employeeId = searchParams.get('employeeId') || '';

  return (
    <Create>
      <SimpleForm>
        <Alert severity="info" sx={{ mb: 2 }}>
          Complete all fields — Annexure 1 of OHS Act requires mandatory reporting for certain incidents
        </Alert>
        <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 1 }}>
          <TextInput source="injuryNumber" label="Reference Number" fullWidth />
          <ReferenceInput source="employee.id" reference="employees" fullWidth defaultValue={employeeId}>
            <SelectInput optionText="name" label="Employee" />
          </ReferenceInput>
          <TextInput source="nature" fullWidth />
        <SelectInput source="severity" choices={INCIDENT_SEVERITY.map(s => ({ id: s, name: s }))} fullWidth />
        <DateField source="incidentDate" label="Incident Date" />
        <SelectInput source="status" choices={INCIDENT_STATUS.map(s => ({ id: s, name: s }))} fullWidth defaultValue="Reported" />
        <SelectInput source="reportedToDol" choices={[{ id: 'true', name: 'Yes' }, { id: 'false', name: 'No' }]} fullWidth label="DOL Reported" />
      </Box>
      <TextInput source="description" multiline fullWidth label="Description (Annexure 1 fields)" />
    </SimpleForm>
  </Create>
  );
};

export const IncidentEdit = () => (
  <Edit>
    <SimpleForm>
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 1 }}>
        <TextInput source="injuryNumber" label="Reference Number" fullWidth />
        <ReferenceInput source="employee.id" reference="employees" fullWidth>
          <SelectInput optionText="name" label="Employee" />
        </ReferenceInput>
        <TextInput source="nature" fullWidth />
        <SelectInput source="severity" choices={INCIDENT_SEVERITY.map(s => ({ id: s, name: s }))} fullWidth />
        <DateField source="incidentDate" label="Incident Date" />
        <SelectInput source="status" choices={INCIDENT_STATUS.map(s => ({ id: s, name: s }))} fullWidth />
        <SelectInput source="reportedToDol" choices={[{ id: 'true', name: 'Yes' }, { id: 'false', name: 'No' }]} fullWidth label="DOL Reported" />
      </Box>
      <TextInput source="description" multiline fullWidth />
    </SimpleForm>
  </Edit>
);
